export const getAutomatedRulesStyles = ({ palette, semanticColors }) => ({
  '& .automated-rules-vnext': {
    '& .different-user-warning.col-sm-10': {
      paddingLeft: 0,
    },
    '& .add-filter-button': {
      marginLeft: 0,
    },
    '& .predicate-list': {
      paddingLeft: 0,
    },
    '& .predicate-pill': {
      '&:hover': {
        background: `${palette.neutralPrimaryAlt} !important`,
      },
    },
    '& .predicate-pill-selected': {
      background: `${palette.themePrimary} !important`,

      '& .predicate-pill': {
        '&:hover': {
          background: `${palette.themeDark} !important`,
        },
      },
      '& .remove': {
        '&:hover': {
          background: `${palette.themeDark} !important`,
        },
      },
    },
    '& .predicate-pill-container': {
      background: palette.neutralSecondary,
    },
    '& .invalid-predicate-pill-container': {
      background: palette.red,
    },
    '& .icon-right.spritedimage.grid-expand-icon.pull-right': {
      border: '0 solid transparent',
      color: '#605e5c',
      display: 'inline-block',
      fontFamily: 'MsAds MDL2 Assets',
      fontSize: '12px',
      fontWeight: 400,
      height: 'auto',
      margin: '0 4px',
      position: 'relative',
      float: 'right',
      width: 'auto',
      '&::before': {
        content: '"\\E76C"',
      },
    },
    '& .radio-inline + .radio-inline': {
      marginLeft: 16,
    },
    '& .error': {
      color: palette.red,
    },
    '& #AutomationRulesBidErrorMessage': {
      display: 'inline-block',
      marginLeft: '30px',
    },
    '& [data-bind*="isIncreaseBudgetHelp"]': {
      display: 'inline-block',
    },
    '& input.search-box__input': {
      marginRight: '0px',
    },
    '& .search-box__icon.glyphicon.filter_search_icon_small:before': {
      content: '"\\E721"',
    },
    '& .search-box__icon.glyphicon.filter_search_icon_small': {
      position: 'absolute',
      top: '10px',
      right: '10px',
      color: '#0078d4',
      fontSize: '14px',
      fontFamily: 'MsAds MDL2 Assets',
    },
    '& .rule-preview-body': {
      '& .previewTable.grid': {
        paddingLeft: '0 !important',
        '& .grid-row': {
          height: 42,
        },
      },
      '& .grid-header-text': {
        lineHeight: '\'19px\'',
        color: palette.neutralPrimary,
        fontWeight: 'normal',
      },
      '& .grid-header-row': {
        height: 42,
      },
      '& tbody .grid-cell': {
        lineHeight: '\'19px\'',
        color: palette.themePrimary,
      },
      '& tbody  .grid-cell  + .grid-cell': {
        lineHeight: '\'16px\'',
        color: '#797775',
      },
    },
    '& .control-label': {
      textAlign: 'left !important',
      width: '100%',
      padding: '12px 0 13px 0',
      marginBottom: '16px',
      display: 'flex',
      fontWeight: 600,
      lineHeight: '19px',
      fontSize: '18px',
      '& label': {
        padding: 0,
      },
      '& span.action-text': {
        fontSize: '14px',
        fontWeight: 'normal',
      },
    },
    '& .panel-body': {
      width: '100%',
      '& > div:not([style="display: none;"])': {
        marginTop: '16px',
      },
      '& > div.margin-zero': {
        marginTop: 0,
      },
      '& .form-group:last-child': {
        marginBottom: 0,
      },
      '& .form-group .formgroupline': {
        width: '787px !important',
        height: '1px',
        color: palette.neutralLight,
        borderTop: '1px solid',
      },
    },
    '& .rule-scope-options-selection': {
      paddingLeft: 0,
    },
    '& .rule-options-selection': {
      padding: '0',
      display: 'inline-block',
      verticalAlign: 'top',
      '& .form-text': {
        marginRight: 8,
      },
      '& .radio-inline': {
        paddingTop: '0',
        width: 94,
        display: 'inline-block',
      },
      '& input[type="radio"]:checked': {
        W: 'none',
        M: 'none',
        appearance: 'none',
        display: 'inline-block',
        height: 18,
        width: 18,
        padding: 4,
        backgroundClip: 'content-box',
        border: `1px solid ${palette.themeDarkAlt}`,
        backgroundColor: palette.themeDarkAlt,
        borderRadius: '50%',
      },
      '& input[type="radio"]': {
        W: 'none',
        M: 'none',
        appearance: 'none',
        display: 'inline-block',
        height: 18,
        width: 18,
        backgroundClip: 'content-box',
        border: `1px solid ${palette.neutralPrimary}`,
        backgroundColor: semanticColors.bodyBackground,
        borderRadius: '50%',
      },
      '& .radio-inline span': {
        marginLeft: 8,
      },
      '& .changeBudgetHelp': {
        display: 'contents',
        '& label': {
          display: 'contents',
        },
      },
      '& .k-datePicker-container': {
        padding: 0,
        '& .k-input': {
          border: 'none',
          height: 30,
          padding: '0px 0px 0px 8px',
        },
      },
    },
    '& select, & input': {
      marginRight: 8,
    },
    '& .bulk-edit-currency': {
      display: 'inline-block',
    },
    '& .bulkEdit-bid': {
      width: 106,
    },
    '& .predicate-row': {
      marginLeft: '0',
      paddingLeft: '0',
    },
    '& .rule-filter-selection': {
      marginLeft: '0',
      padding: '0',
      width: '100% !important',
      '& .glyphicon.glyphicon-remove': {
        marginTop: 6,
        color: palette.neutralSecondary,
        lineHeight: '12px',
        fontSize: 12,
        fontFamily: 'MsAds MDL2 Assets',
        verticalAlign: 'middle',
      },
      '& .glyphicon-remove:before': {
        content: '"\\E711" !important',
      },
      '& .new': {
        color: palette.neutralPrimary,
      },
      '& .glyphicon.glyphicon-plus': {
        marginRight: 8,
        height: 14,
        width: 14,
        fontFamily: 'MsAds MDL2 Assets',
        color: palette.themePrimary,
      },
      '& .glyphicon-plus:before': {
        content: '"\\E710" !important',
      },
      '& .delivery-status-category-container:first-of-type': {
        float: 'left',
        marginLeft: '20px',
        display: 'inline-block',
        marginTop: 0,
      },

      '& .delivery-status-category-container + .delivery-status-category-container': {
        paddingLeft: 20,
        float: 'left',
      },
      '& .predicate-row': {
        alignItems: 'end',
      },
    },
    '& .frequency-selection': {
      display: 'inline-block',
      '& div[role="radiogroup"]': {
        display: 'flex',
        alignItems: 'center',
        '& #ImprovedAdScheduling_Display_Time_Label': {
          width: 'auto',
          paddingBottom: 0,
        },
      },
    },
  },
});
